const fetchWrapper = (url, ...args) => {

  // To enable debugging…
  if ('production' !== process.env.NODE_ENV && /(\?|&)debug(&.*)?$/.test(window.location.search)) {

    url = url + (!/\?/.test(url) ? '?' : '&') + 'XDEBUG_SESSION_START=phpstorm';

  }

  return window.fetch(url, ...args);

};

export default fetchWrapper;


// WEBPACK FOOTER //
// ./src/utils/fetch.js